import React from 'react';
import PropTypes from 'prop-types';

const TimedProgressSection = ({ alignment, desc, title }) => (
  <div className={`c-m-timed-progress__${alignment}`}>
    <div className="c-m-timed-progress__description">{desc}</div>
    <div className="c-m-timed-progress__progress">
      <div className="c-m-timed-progress__title">{title}</div>
    </div>
  </div>
);

export const sectionShape = {
  desc: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  iconType: PropTypes.string
};

TimedProgressSection.propTypes = {
  alignment: PropTypes.oneOf(['left', 'right']).isRequired,
  ...sectionShape
};

export { TimedProgressSection };
